import { render, staticRenderFns } from "./UserTimeline.vue?vue&type=template&id=a4c1fd02&scoped=true"
import script from "./UserTimeline.vue?vue&type=script&lang=js"
export * from "./UserTimeline.vue?vue&type=script&lang=js"
import style0 from "./UserTimeline.vue?vue&type=style&index=0&id=a4c1fd02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c1fd02",
  null
  
)

export default component.exports